import styled from 'styled-components';

export const TripInfoActionWrap = styled.div(
    props => `
        width: 25%;
        display: flex;
        flex-direction: column;
    `
);

export const TripInfoActionInner = styled.div(
    props => `
        display: flex;
        align-items: center;
        margin-bottom: ${props.theme.spacing.base};
        cursor: pointer;
    `
);

export const TripActionIconWrap = styled.p(
    props => `
        width: 2.4rem;
        height: 2.4rem;
        margin-right: ${props.theme.spacing.base};
        cursor: pointer;
        align-items: center;
        display: flex;
    `
);


export const TripActionIconWrapWhatsApp = styled.div(
    props => `
        margin-right: ${props.theme.spacing.base};
        cursor: pointer;

    `
);

export const TripInfoActionText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.blue.base};
        font-weight: ${props.theme.font.fontWeight.bold};
    `
);